import { ArrowForward } from "@mui/icons-material";
import { ReactComponent as CheckCircleOutline } from '../../assets/check2-circle.svg';
import { Box, CardActionArea, CardActions, CardContent, CardMedia, Typography } from "@mui/material";
import { Button } from "react-bootstrap";
import { useContext } from "react";
import ReferralClientEnrolmentFormContext from "./referral-client-enrolment-context";
import Footer from "../footer";

type Props = {
    onUpgrade: () => void;
} 
const ReferralPlanForm = ({onUpgrade}: Props) => {
    const { priceDetail } = useContext(ReferralClientEnrolmentFormContext);
    return (
      <>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            component="img"
            src="/assets/BG-SmilingFaces.png"
            alt="Smiling Faces Background"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 0,
            }}
          />

          <Box
            sx={{
              position: 'relative',
              zIndex: 1,
              p: 4,
              flex: '1 0 auto',
            }}
          >
            <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
              Upgrade to unlock <br /> full protection.
            </Typography>
            <Typography variant="body2" sx={{ mt: 2, fontWeight: 500 }}>
              Whether it’s up-to-date alerts on your tax file, or protection <br />
              from costly audits – Optima has you covered.
            </Typography>

            <div className="d-flex">
              <Typography variant="h5" sx={{ color: '#1589D2', fontWeight: 'bold', mt: 1, mr: 1 }}>
                {'$' + priceDetail.MonthlyPrice}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1.7, color: '#667085' }}>
                {'/mo + tax (NM, SD, HI)'}
              </Typography>
            </div>

            <Typography variant="body2" className="mt-3">
              <CheckCircleOutline className="me-1" /> Monthly Tax Report
            </Typography>
            <Typography variant="body2" className="mt-1">
              <CheckCircleOutline className="me-1" /> Lifetime Audit Defense*
            </Typography>
            <Typography variant="body2" className="mt-1">
              <CheckCircleOutline className="me-1" /> IRS Tax Authorization (8821) Filed
            </Typography>
            <Typography variant="body2" className="mt-1">
              <CheckCircleOutline className="me-1" /> Professional Tax Preparation Services
            </Typography>
            <Typography variant="body2" className="mt-1">
              <CheckCircleOutline className="me-1" /> Tax ID Fraud Remediation
            </Typography>
            <Typography variant="body2" className="mt-1">
              <CheckCircleOutline className="me-1" /> Discounted Tax Resolution Services
            </Typography>

            <CardActions>
              <Button className="plan-fill-button mt-3" onClick={onUpgrade}>
                Upgrade to Unlock Access <ArrowForward />
              </Button>
            </CardActions>

            <Typography className="fs-10px">
              * Lifetime dependent on being active customer of any Optima Tax Shield Plan.
              <br />
              Please review Protection Agreement for details and limitations.
            </Typography>
          </Box>

          <Box sx={{ zIndex: 1, flexShrink: 0 }}>
            <Footer />
          </Box>
        </Box>
      </>
    );
}

export default ReferralPlanForm;